<template>
  <div class="wgt-devices">
    <SpImage src="https://cdn-image.tjtjshengtu.com/icon/equipment.png"/>
  </div>
</template>

<script>
import config from './config'
export default {
  name: 'Devices',
  wgtName: '设备绑定',
  wgtDesc: '',
  wgtIcon: 'wgt-suspension',
  wgtType: 1,
  wgtTem: 1,//0代表微信和抖音小程序都可以配置,1代表只能配置微信
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
    }
  },
  components: {
  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss" scoped>
.wgt-suspension {
  box-sizing: border-box;
  min-height: 20px;

  .wgt-suspension-content {
    position: relative;
  }
}
</style>